import { useState, useRef, useEffect } from 'react'
import { Image } from 'antd';
import { handleSrcContent } from '@/utils';
import { CloseCircleFilled, EyeOutlined, MinusOutlined, PlusOutlined, RedoOutlined } from '@ant-design/icons'
import './AuthUploadImg.less'

const AuthUploadImg = (props) => {
  const [preview, setPreview] = useState(false)

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [previewSrc, setPreviewSrc] = useState(null);
  const [zoom, setZoom] = useState(1);
  const [baseScale, setBaseScale] = useState(1);
  const [translate, setTranslate] = useState({ x: 0, y: 0 });
  const [dragging, setDragging] = useState(false);

  const containerRef = useRef(null);
  const previewStageRef = useRef(null);
  const naturalSizeRef = useRef({ width: 0, height: 0 });
  const dragStateRef = useRef({ startX: 0, startY: 0, originX: 0, originY: 0 });

  const clampZoom = (val) => Math.min(10, Math.max(0.1, val));

  const resetView = () => {
    setZoom(1);
    setTranslate({ x: 0, y: 0 });
  };

  const updateBaseScale = (naturalWidth, naturalHeight) => {
    const stage = previewStageRef.current;
    if (!stage) return;

    const rect = stage.getBoundingClientRect();
    const fitScale = Math.min(
      1,
      (rect.width * 0.9) / naturalWidth,
      (rect.height * 0.9) / naturalHeight
    );

    setBaseScale(Number.isFinite(fitScale) && fitScale > 0 ? fitScale : 1);
  };

  const openPreview = (src) => {
    if (!src) return;
    setPreviewSrc(src);
    setIsModalVisible(true);
    setBaseScale(1);
    resetView();
  };

  const closePreview = () => {
    setIsModalVisible(false);
    setPreviewSrc(null);
    setPreview(false);
    setBaseScale(1);
    resetView();
  };

  useEffect(() => {
    if (!dragging) return;

    const onMove = (e) => {
      const { startX, startY, originX, originY } = dragStateRef.current;
      const dx = e.clientX - startX;
      const dy = e.clientY - startY;
      setTranslate({ x: originX + dx, y: originY + dy });
    };

    const onUp = () => {
      setDragging(false);
    };

    window.addEventListener('mousemove', onMove);
    window.addEventListener('mouseup', onUp);

    return () => {
      window.removeEventListener('mousemove', onMove);
      window.removeEventListener('mouseup', onUp);
    };
  }, [dragging]);

  useEffect(() => {
    if (!isModalVisible) return;

    const onResize = () => {
      const { width, height } = naturalSizeRef.current;
      if (!width || !height) return;
      updateBaseScale(width, height);
    };

    window.addEventListener('resize', onResize);

    return () => {
      window.removeEventListener('resize', onResize);
    };
  }, [isModalVisible]);

  // 支持 ESC 关闭预览
  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === 'Escape') {
        closePreview();
      }
    };
    window.addEventListener('keydown', handleEsc);
    return () => {
      window.removeEventListener('keydown', handleEsc);
    };
  }, []);
  useEffect(() => {
    const handleMouseEnter = () => setPreview(true);
    const handleMouseLeave = () => setPreview(false);

    const container = containerRef.current;
    if (container) {
      container.addEventListener('mouseenter', handleMouseEnter);
      container.addEventListener('mouseleave', handleMouseLeave);

      return () => {
        container.removeEventListener('mouseenter', handleMouseEnter);
        container.removeEventListener('mouseleave', handleMouseLeave);
      };
    }
  }, []);
  return (
    <div className='hoverImg'
      style={{
        ...props.style,
        borderRadius: props.borderRadius ? props.borderRadius : 0,
        display: props.src ? 'block' : 'none',
        width: props.width ? props.width : props.iw ? props.iw : 344,
        height: props.height ? props.height : props.ih ? props.ih : 144,
        position: 'relative',
      }}
      ref={containerRef}
    >
      {/* {handleSrcContent(props.src)} */}
      {typeof props.src === 'string' ? <>
        <Image
          width={props.width ? props.width : props.iw ? props.iw : 344}
          height={props.height ? props.height : props.ih ? props.ih : 144}
          style={{
            border: props.border ? '1px solid #f2f3f4' : 'none',
            borderRadius: props.borderRadius ? props.borderRadius : 0
          }}
          preview={false}
          src={handleSrcContent(props.src)}
        />

        <div
          className='previewMask'
          style={{

            display: preview ? 'flex' : 'none',
        borderRadius: props.borderRadius ? props.borderRadius : 0,

            width: props.width ? props.width : props.iw ? props.iw : 344,
            height: props.height ? props.height : props.ih ? props.ih : 144,
          }}
          onClick={() => {
            // 单图时点击蒙层预览；多图场景不在这里触发（在每张图片上绑定）
            if (typeof props.src === 'string') {
              openPreview(props.src);
            }
          }}
        >
          <EyeOutlined style={{ marginRight: 5 }} />
          预览
        </div>

        {props.isDelete ? <CloseCircleFilled onClick={() => {
          // 父组件的删除事件！！！
          props.onDelete(null)
        }} style={{ background: '#fff', position: 'absolute', top: -5, right: -5, zIndex: 9999, fontSize: 24,borderRadius: 50, color: '#999', }} /> : null}
      </> : <div className='flex'>
        {props.src && props.src.length
          ? props.src.map((item, index) => {
            return (
              <>
                <Image
                  preview={false}
                  width={props.width ? props.width : props.iw ? props.iw : 344}
                  height={props.height ? props.height : props.ih ? props.ih : 144}
                  style={{
                    ...props.style,
                    border: props.border ? '1px solid #f2f3f4' : 'none',
                    borderRadius: props.borderRadius ? props.borderRadius : 0
                  }}
                  src={handleSrcContent(item)}
                  onClick={() => {
                    // 每张图片点击进入自定义预览
                    openPreview(item);
                  }}
                />
                {props.isDelete ? <CloseCircleFilled onClick={() => {
                  // 父组件的删除事件！！！
                  let images = [...props.src]
                  images.splice(index, 1)
                  props.onDelete(images && images.length ? images : null)
                }} style={{ background: '#fff', position: 'absolute', fontSize: 24,borderRadius: 50, color: '#999', top: -5, right: -5, zIndex: 9999 }} /> : null}
                {/* 图片预览蒙层 */}
                <div
                  className='previewMask'
                  style={{
                    display: preview ? 'flex' : 'none',
                    width: props.width ? props.width : props.iw ? props.iw : 344,
                    height: props.height ? props.height : props.ih ? props.ih : 144,
                    borderRadius: props.borderRadius ? props.borderRadius : 0
                  }}
                  onClick={() => {
                    // 单图时点击蒙层预览；多图场景不在这里触发（在每张图片上绑定）
                    if (typeof item === 'string') {
                      openPreview(item);
                    }
                  }}
                >
                  <EyeOutlined style={{ marginRight: 5 }} />
                  预览
                </div>
              </>
            )
          }) : null}


      </div>}
      {/* 自定义图片预览覆盖层（非 Image 组件） */}

      {isModalVisible ? (
        <div
          className='imgPreviewOverlay'
          onClick={closePreview}
          style={{
            position: 'fixed',
            inset: 0,
            zIndex: 999999,
            background: 'rgba(0,0,0,0.6)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <div
            ref={previewStageRef}
            onClick={(e) => e.stopPropagation()}
            onWheel={(e) => {
              e.preventDefault();
              e.stopPropagation();
              const step = e.deltaY > 0 ? -0.12 : 0.12;
              setZoom((z) => clampZoom(z + step));
            }}
            onMouseDown={(e) => {
              e.preventDefault();
              e.stopPropagation();
              dragStateRef.current = {
                startX: e.clientX,
                startY: e.clientY,
                originX: translate.x,
                originY: translate.y
              };
              setDragging(true);
            }}
            style={{
              width: '100vw',
              height: '100vh',
              overflow: 'hidden',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              touchAction: 'none'
            }}
          >
            <img
              src={handleSrcContent(previewSrc)}
              alt="预览"
              draggable={false}
              onLoad={(e) => {
                const { naturalWidth, naturalHeight } = e.currentTarget;
                naturalSizeRef.current = { width: naturalWidth, height: naturalHeight };
                updateBaseScale(naturalWidth, naturalHeight);
              }}
              style={{
                transform: `translate(${translate.x}px, ${translate.y}px) scale(${baseScale * zoom})`,
                transformOrigin: 'center center',
                maxWidth: 'none',
                maxHeight: 'none',
                userSelect: 'none',
                cursor: dragging ? 'grabbing' : 'grab',
                borderRadius: 4,
                boxShadow: '0 10px 30px rgba(0,0,0,0.5)'
              }}
            />
          </div>

          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              position: 'fixed',
              left: '50%',
              bottom: 24,
              transform: 'translateX(-50%)',
              display: 'flex',
              alignItems: 'center',
              gap: 12,
              padding: '8px 12px',
              borderRadius: 24,
              background: 'rgba(0,0,0,0.55)',
              color: '#fff',
              fontSize: 14
            }}
          >
            <MinusOutlined
              style={{ cursor: 'pointer' }}
              onClick={() => setZoom((z) => clampZoom(z - 0.2))}
            />
            <span style={{ minWidth: 64, textAlign: 'center' }}>
              {Math.round(baseScale * zoom * 100)}%
            </span>
            <PlusOutlined
              style={{ cursor: 'pointer' }}
              onClick={() => setZoom((z) => clampZoom(z + 0.2))}
            />
            <RedoOutlined style={{ cursor: 'pointer' }} onClick={resetView} />
          </div>

          <CloseCircleFilled
            onClick={(e) => { e.stopPropagation(); closePreview(); }}
            style={{
              position: 'fixed',
              top: 24,
              right: 24,
              fontSize: 22,
              zIndex: 9999,
              color: '#fff',
              cursor: 'pointer'
            }}
          />
        </div>
      ) : null}
    </div>

  )

}

export default AuthUploadImg;